import {
  type LoadGeneratorHeader,
  type LoadGeneratorWithWebhooks,
  type LoadGeneratorWebhook
} from 'types/api/services/load-generator'
import { type EvaluationConfiguration } from 'types/api/status-checks/evaluation'
import { type TeamExternalIntegration } from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const k6LoadGeneratorIntegration = {
  name: 'Grafana Cloud K6',
  type: IntegrationType.K6,
  authUrl: `${ENDPOINT_URLS.k6}v3/organizations`,
  isPrivateNetworkIntegration: false,
  headers: [{ key: 'Authorization', value: '', label: 'API Key' }],
  url: ENDPOINT_URLS.k6,
  sortIndex: 7,
  isConfigured: false
} as TeamExternalIntegration

export const k6ApiUrlRegex = new RegExp(
  '^https:\\/\\/(.+).k6.io\\/v\\d/(organizations)'
)

export function convertToK6Url(url: string) {
  return k6ApiUrlRegex.test(url) ? url : null
}

export function convertLoadGeneratorHeadersToRequestHeaders(
  headers: LoadGeneratorHeader[]
) {
  return headers
    .map((h) => ({
      [h.key]: h.value
    }))
    .reduce((acc, curr) => ({ ...acc, ...curr }), {})
}

export const webhookTypeByName = {
  LOAD_GENERATOR_TRIGGER: 'webhookStartLoadTrigger',
  LOAD_GENERATOR_STATUS_CHECK: 'webhookStatusCheck',
  LOAD_GENERATOR_STOP: 'webhookStopLoadTrigger'
}

export const MAX_LOAD_GENERATOR_NAME_LENGTH = 128

export const loadGeneratorWebhookMethods = {
  webhookStartLoadTrigger: [{ label: 'POST', value: 'POST' }],
  webhookStatusCheck: [{ label: 'GET', value: 'GET' }],
  webhookStopLoadTrigger: [
    { label: 'POST', value: 'POST' },
    { label: 'PUT', value: 'PUT' },
    { label: 'PATCH', value: 'PATCH' }
  ]
}

export const defaultLoadGeneratorEvaluationConfiguration: EvaluationConfiguration =
  {
    okLatencyMaxMs: 5000,
    okStatusCodes: ['200', '201', '202', '204'],
    responseBodyEvaluation: {
      op: 'AND',
      predicates: []
    }
  }

//modify get load generator response to have the same model as LoadGeneratorWithWebhooks
export function createLoadGeneratorWithWebhooksObject(
  object
): LoadGeneratorWithWebhooks | undefined {
  if (!object) return undefined
  const {
    webhookStartLoadTrigger,
    webhookStatusCheck,
    webhookStopLoadTrigger,
    ...objectFinal
  } = object
  const modifyWebhookObj = (webhook) => {
    const { webhookEndpoint, ...webhookFinal } = webhook
    return {
      ...webhookFinal,
      ...webhookEndpoint
    } as LoadGeneratorWebhook
  }
  return {
    ...objectFinal,
    webhookStartLoadTrigger: modifyWebhookObj(webhookStartLoadTrigger),
    ...(webhookStatusCheck && {
      webhookStatusCheck: modifyWebhookObj(webhookStatusCheck)
    }),
    ...(webhookStopLoadTrigger && {
      webhookStopLoadTrigger: modifyWebhookObj(webhookStopLoadTrigger)
    })
  }
}
